import * as EtlRepo from '@/repository/etl.js';

const state = {
	currentJob: null,
	jobPromise: null,
	jobLatest: null,
	startTime: 0,
	lastUpdate: 0,
	extracted: {
		added: 0,
		skipped: 0,
		created: 0,
		updated: 0,
		unloaded: 0,
		processed: 0,
		errors: [],
	},
};

const getters = {
	progress: (state) => {
		if (!state.jobLatest) return {};
		return state.jobLatest;
	},
	elapsed: (state) => {
		return state.lastUpdate - state.startTime;
	},
	rate: (state, getters) => {
		const p = state.jobLatest?.stats?.processed || 0;
		const el = getters.elapsed > 1000 ? getters.elapsed / 1000 : 1;
		return p / el;
	},
	eta: (state, getters) => {
		const rate = getters.rate;
		if (rate <= 0) return 0;
		const rem =
			(state.jobLatest?.stats?.added || 1) - (state.jobLatest?.stats?.processed || 0);
		return rem / rate;
	},
};

const mutations = {
	setCurrentJob(state, job) {
		state.currentJob = job;
	},
	setJobPromise(state, promise) {
		state.jobPromise = promise;
	},
	setJobLatest(state, job) {
		state.jobLatest = job;
	},
	setStartTime(state, time) {
		state.startTime = time;
	},
	setLastUpdate(state, time) {
		state.lastUpdate = time;
	},
	setExtracted(state, stats) {
		state.extracted.added = stats.added;
		state.extracted.created = stats.created;
		if (Array.isArray(stats.errors)) {
			state.extracted.errors = stats.errors;
		}
		state.extracted.processed = stats.processed;
		state.extracted.skipped = stats.skipped;
		state.extracted.updated = stats.updated;
		state.extracted.unloaded = stats.unloaded;
	},
	resetJob(state) {
		state.currentJob = null;
		state.jobPromise = null;
		state.jobLatest = null;
		state.startTime = 0;
		state.lastUpdate = 0;
		state.extracted = {
			added: 0,
			skipped: 0,
			created: 0,
			updated: 0,
			unloaded: 0,
			processed: 0,
			errors: [],
		};
	},
};

const actions = {
	async createJob({ commit }, params) {
		if (params.config.length !== 36) {
			const tpl = await EtlRepo.getConfig({ alias: params.config });
			params.config = tpl.id;
		}
		commit('resetJob');
		const job = await EtlRepo.createJob(params);
		commit('setCurrentJob', job);
		commit('setJobLatest', job);
	},
	async startJob({ state, commit, dispatch }) {
		const job = await EtlRepo.startJob({ job: state.currentJob.id });
		commit('setCurrentJob', job);
		commit('setJobLatest', job);
		return dispatch('tryContinue');
	},
	tryContinue({ state, commit }, jobId) {
		if (!state.currentJob) return;
		const startTime = Date.now();
		commit('setStartTime', startTime);
		const promise = EtlRepo.pollUntilJobComplete(
			jobId || state.currentJob.id,
			1000,
			1000 * 60 * 20,
			(update) => {
				console.log('poll update', update.status, update.stats);
				if (startTime !== state.startTime || !state.currentJob) return;
				commit('setJobLatest', update);
				commit('setLastUpdate', Date.now());
				commit('setExtracted', update.stats);
			}
		);
		commit('setJobPromise', promise);
		return promise;
	},
	resetJob({ commit }) {
		commit('resetJob');
	},
	async loadLastJob({ state, dispatch }) {
		try {
			if (!state.currentJob?.id) return;
			const jobId = state.currentJob.id;
			const job = await EtlRepo.getJob({ job: jobId });
			if (['running', 'queued'].includes(job.status)) {
				dispatch('tryContinue', job.id);
			}
		} catch (e) {
			console.log('cannot load last job', e);
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};